import {
    MDBBtn,
    MDBCol,
    MDBContainer,
    MDBIcon,
    MDBRow
} from 'mdb-react-ui-kit';
import React, { useEffect, useState } from 'react';
import {
    createGoogleOauthUrl,
    createMicrosoftOauthUrl,
    getGoogleClientId,
    getMicrosoftClientId,
    getMicrosoftTenantId,
    showErrorToast
} from '../../helpers';
import { useSearchParams } from 'react-router-dom';

const Main = () => {
    const [searchParams, setSearchParams] = useSearchParams();

    const [isLoading, setIsLoading] = useState(true);

    const [googleOauthUrl, setGoogleOauthUrl] = useState('');
    const [microsoftOauthUrl, setMicrosoftOauthUrl] = useState('');

    useEffect(() => {
        setIsLoading(true);

        const fetchOauthUrls = async () => {
            const [
                googleClientIdResponse,
                microsoftTenantIdResponse,
                microsoftClientIdResponse,
            ] = await Promise.all([
                getGoogleClientId(),
                getMicrosoftTenantId(),
                getMicrosoftClientId(),
            ]);

            const flow = searchParams.get('flow');

            // PD login
            if (flow === 'publisher_dashboard' && searchParams.has('origin')) {
                const publisherOrigin = searchParams.get('origin');

                setGoogleOauthUrl(
                    createGoogleOauthUrl(googleClientIdResponse.data, flow, 'publisherOrigin', publisherOrigin)
                );

                setMicrosoftOauthUrl(
                    createMicrosoftOauthUrl(
                        microsoftTenantIdResponse.data,
                        microsoftClientIdResponse.data,
                        flow,
                        'publisherOrigin',
                        publisherOrigin
                    )
                );

            // Hub UI Freshdesk login
            } else if (flow === 'freshdesk_hub') {
                setGoogleOauthUrl(
                    createGoogleOauthUrl(googleClientIdResponse.data, flow)
                );

                setMicrosoftOauthUrl(
                    createMicrosoftOauthUrl(
                        microsoftTenantIdResponse.data,
                        microsoftClientIdResponse.data,
                        flow,
                    )
                );
            }

            setIsLoading(false);
        };

        fetchOauthUrls();
    }, []);

    const handleGoogleOauthClick = () => {
        if (googleOauthUrl) {
            window.location.href = googleOauthUrl;
        } else {
            showErrorToast('Could not find a Google authorization URL');
        }
    };

    const handleMicrosoftOauthClick = () => {
        if (microsoftOauthUrl) {
            window.location.href = microsoftOauthUrl;
        } else {
            showErrorToast('Could not find a Microsoft authorization URL');
        }
    };

    return (
        <MDBContainer>
            <MDBRow className="mb-4 mt-4">
              <MDBCol className='d-flex justify-content-center'>
                <h4>Login via:</h4>
              </MDBCol>
            </MDBRow>
            <MDBRow className='d-flex justify-content-center'>
                <MDBCol md={8} className='d-flex justify-content-center'>
                    <MDBBtn
                        disabled={isLoading}
                        className='me-3'
                        onClick={handleGoogleOauthClick}
                    >
                        {isLoading
                            ?
                            <MDBIcon icon='fas fa-solid fa-spinner fa-spin' className='me-3' size='xl'/>
                            :
                            <MDBIcon icon='fas fa-brands fa-google' className='me-3' size='xl'/>
                        }
                        <b>Google</b>
                    </MDBBtn>
                    <MDBBtn
                        disabled={isLoading}
                        onClick={handleMicrosoftOauthClick}
                    >
                        {isLoading
                            ?
                            <MDBIcon icon='fas fa-solid fa-spinner fa-spin' className='me-3' size='xl'/>
                            :
                            <MDBIcon icon='fas fa-brands fa-microsoft' className='me-3' size='xl'/>
                        }
                        <b>Microsoft</b>
                    </MDBBtn>
                </MDBCol>
            </MDBRow>
            <MDBRow className="mb-4 mt-4 d-flex justify-content-center">
                <MDBCol md={5}>
                    <hr/>
                </MDBCol>
            </MDBRow>
        </MDBContainer>
  );
};

export default Main;
